import { routes } from '../routes/routes'
import React from 'react'
import { Route } from 'react-router-dom'

export const router = () => {
  return (routes.map((iterator) => {
    return <Route exact path={iterator.path} component={iterator.component} />
  }))
}